import type { FC } from "react";
import { useEffect, useState } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { SharingService } from "app/sharing/SharingService";

import { UsersAutocomplete } from "./UsersAutocomplete";
import type { IUser } from "./UsersAutocomplete";

interface IUsersAutocompleteWrapper {
    selectedUsersIDs: Array<number>;
    onRemoveUser: (user: IUser) => void;
    onUserSelect: (user: IUser) => void;
}

export const UsersAutocompleteWrapper: FC<IUsersAutocompleteWrapper> = (props) => {
    const { selectedUsersIDs = [], onUserSelect, onRemoveUser } = props;
    const [allUsers, setAllUsers] = useState([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const handleResponse = (response) => {
        setAllUsers(response.users);
        setIsLoading(false);
    };
    useEffect(() => {
        setIsLoading(true);
        SharingService.getAccountUsers().then(handleResponse);
    }, []);
    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                width={"100%"}
                height={selectedUsersIDs.length > 0 ? 90 : 45}
            />
        );
    }
    const selectedUsers = allUsers.filter(({ Id }) => selectedUsersIDs.includes(Id));
    return (
        <UsersAutocomplete
            allUsers={allUsers}
            selectedUsers={selectedUsers}
            onRemoveUser={onRemoveUser}
            onUserSelect={onUserSelect}
        />
    );
};
